import { useMemo, useState } from "react";
import type { SessionUser } from "../../shared/auth/access";
import type { CapaStatus } from "./domain/models";
import { visibleCapaRecords } from "./capa-presentation";
import { useCapaListWorkspace } from "./useCapaListWorkspace";
import { useCapaFormWorkspace } from "./useCapaFormWorkspace";

export function useQualityCapaWorkspace({ user, notify, dataRefreshVersion }: { user: SessionUser; notify: (message: string) => void; dataRefreshVersion: number }) {
  const [search, setSearch] = useState("");
  const [stage, setStage] = useState<CapaStatus | null>(null);
  const [expanded, setExpanded] = useState<string | null>(null);
  const scopeKey = `${user.id}:${user.role}`;
  const list = useCapaListWorkspace(scopeKey, dataRefreshVersion, notify);
  const form = useCapaFormWorkspace({ scopeKey, notify, load: list.load });
  const visible = useMemo(() => visibleCapaRecords(list.records, search, stage), [list.records, search, stage]);
  return { ...list, ...form, search, setSearch, stage, setStage, expanded, setExpanded, visible };
}
